import React, { useState, useContext, useRef } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import api from "../../api/candidate.resource";
import { AccountMenu } from "../common/AccountMenu";
import { defaultToastOptions, passwordRegex } from "../../constants/constants";
import { UserContext } from "../context/UserContext";
import CDK_GLOBAL_CIRCULAR_LOGO from "../../images/CDK-Circular-Logo.png";
import CHANGE_PASSWORD from "../../images/Change-Password.svg";
import useValidation from "../../util/useValidation";

export const ChangePassword = ({ history }) => {
  const [userCredentials, setUserCredentials] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [changePasswordError, setChangePasswordError] = useState();
  const { handleOnBlurValidation, errors } = useValidation();
  const { userDetails } = useContext(UserContext);
  const userForm = useRef(null);

  const handleOnChangeInput = e => {
    const { name, value } = e.target;
    setUserCredentials(prevState => ({
      ...prevState,
      [name]: value
    }));
    setChangePasswordError("");
  };

  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const handleOnClickChangePassword = async e => {
    try {
      e.preventDefault();
      toast.configure();
      const credentials = { ...userCredentials, id: userDetails.id };
      const res = await api.changePassword(credentials);
      if (res) {
        if (res.errorMessage) {
          setChangePasswordError(res.errorMessage);
        } else {
          toast.success("Changed Password Succesfully", defaultToastOptions);
          history.push("/");
        }
      }
    } catch (e) {
      toast.error("Error while Changing Password", defaultToastOptions);
    }
  };

  const isValidFormData = () => {
    return userForm.current && userForm.current.checkValidity();
  };

  return (
    <Container className="login-pages-container">
      <div className="change-password-account-menu">
        <AccountMenu />
      </div>
      <img
        className="change-password-img"
        src={CHANGE_PASSWORD}
        alt="ChangePasswordImg"
      />
      <div className="login-controls-container">
        <div className="login-controls">
          <img
            className="cdk-circular-logo"
            src={CDK_GLOBAL_CIRCULAR_LOGO}
            alt="CDKGlobalCircularLogo"
          />
          <h4 className="font-weight-bold">Reset Password</h4>
          <p>Reset your old password with new password</p>
          <Form
            noValidate
            onSubmit={handleOnClickChangePassword}
            ref={userForm}
          >
            <div className="login">
              <Form.Control
                size="lg"
                type="password"
                id="oldPassword"
                className="input"
                name="oldPassword"
                placeholder="Old Password"
                onChange={handleOnChangeInput}
                required
                onBlur={handOnBlurInput}
                isInvalid={errors.oldPassword}
              />
              {errors.oldPassword && (
                <Form.Control.Feedback type="invalid">
                  {errors.oldPassword.type === "required" &&
                    "Please enter your Old Password"}
                </Form.Control.Feedback>
              )}
              <Form.Control
                size="lg"
                type="password"
                id="newPassword"
                className="input"
                name="newPassword"
                placeholder="New Password"
                pattern={passwordRegex}
                onChange={handleOnChangeInput}
                required
                onBlur={handOnBlurInput}
                isInvalid={errors.newPassword}
              />
              {errors.newPassword && (
                <Form.Control.Feedback type="invalid">
                  {errors.newPassword.type === "required" &&
                    "Please enter your new password"}
                  {errors.newPassword.type === "pattern" &&
                    "Password is not strong."}
                </Form.Control.Feedback>
              )}

              <Form.Control
                size="lg"
                type="password"
                id="confirmPassword"
                className="input"
                name="confirmPassword"
                placeholder="Re-enter Password"
                pattern={passwordRegex}
                onChange={handleOnChangeInput}
                required
                onBlur={handOnBlurInput}
                isInvalid={errors.confirmPassword}
              />
              {errors.confirmPassword && (
                <Form.Control.Feedback type="invalid">
                  {errors.confirmPassword.type === "required" &&
                    "Please Re-enter password"}
                  {errors.confirmPassword.type === "pattern" &&
                    "Password is not strong."}
                </Form.Control.Feedback>
              )}
              <p className="text-center pt-4">
                Note: Minimum of 8 Characters and Should contain <br /> lower,
                uppercase, numeric & special character.
              </p>
              {!!changePasswordError && (
                <div className="error">{changePasswordError}</div>
              )}
              <Button
                variant=""
                type="submit"
                size="lg"
                className="onLogin text-nowrap"
                disabled={!isValidFormData()}
              >
                Reset Password
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Container>
  );
};
export default ChangePassword;
